// @generated by protoc-gen-es v1.9.0 with parameter "target=ts"
// @generated from file no/jotta/openapi/wopi.proto (package no.jotta.openapi, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * @generated from enum no.jotta.openapi.WopiActionType
 */
export var WopiActionType;
(function (WopiActionType) {
    /**
     * @generated from enum value: UNKNOWN_ACTION_TYPE = 0;
     */
    WopiActionType[WopiActionType["UNKNOWN_ACTION_TYPE"] = 0] = "UNKNOWN_ACTION_TYPE";
    /**
     * @generated from enum value: VIEW = 1;
     */
    WopiActionType[WopiActionType["VIEW"] = 1] = "VIEW";
    /**
     * @generated from enum value: EDIT = 2;
     */
    WopiActionType[WopiActionType["EDIT"] = 2] = "EDIT";
    /**
     * EDITNEW creates a new document using a blank file template appropriate to the file type given,
     * then opens that file for editing in Office for the web.
     *
     * @generated from enum value: EDITNEW = 3;
     */
    WopiActionType[WopiActionType["EDITNEW"] = 3] = "EDITNEW";
    /**
     * An action that returns a set of URLs that can be used to execute automated test cases.
     * This action is only used by the WOPI Validation application and is meant to be used in an automated fashion.
     *
     * @generated from enum value: GETINFO = 4;
     */
    WopiActionType[WopiActionType["GETINFO"] = 4] = "GETINFO";
    /**
     * An action that renders a non-editable view of a document that is optimized for embedding in a web page.
     *
     * @generated from enum value: EMBEDVIEW = 5;
     */
    WopiActionType[WopiActionType["EMBEDVIEW"] = 5] = "EMBEDVIEW";
    /**
     * Convert converts a binary document like .doc or .xls to a more modern document format like docx, xlsx.
     * For usage see: https://docs.microsoft.com/en-us/microsoft-365/cloud-storage-partner-program/online/scenarios/conversion
     *
     * Convert action works by having office online read the old document, then write the converted document to a new file using PutRelativeFile.
     * After writing the new document, Office Online will redirect the topmost window (window.top) to a url for the newly converted document,
     * this url is provided by the backend server as the HostEditUrl, returned in the PutRelativeFile response.
     *
     * Office Online always redirects the topmost window (window.top).
     *
     * @generated from enum value: CONVERT = 6;
     */
    WopiActionType[WopiActionType["CONVERT"] = 6] = "CONVERT";
})(WopiActionType || (WopiActionType = {}));
// Retrieve enum metadata with: proto3.getEnumType(WopiActionType)
proto3.util.setEnumType(WopiActionType, "no.jotta.openapi.WopiActionType", [
    { no: 0, name: "UNKNOWN_ACTION_TYPE" },
    { no: 1, name: "VIEW" },
    { no: 2, name: "EDIT" },
    { no: 3, name: "EDITNEW" },
    { no: 4, name: "GETINFO" },
    { no: 5, name: "EMBEDVIEW" },
    { no: 6, name: "CONVERT" },
]);
/**
 * @generated from enum no.jotta.openapi.WopiConsent
 */
export var WopiConsent;
(function (WopiConsent) {
    /**
     * @generated from enum value: WOPI_CONSENT_UNKNOWN = 0;
     */
    WopiConsent[WopiConsent["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * Customer has accepted terms and you can open documents using office online.
     *
     * @generated from enum value: WOPI_CONSENT_ACCEPTED = 1;
     */
    WopiConsent[WopiConsent["ACCEPTED"] = 1] = "ACCEPTED";
    /**
     * Customer has actively declined terms and you can _not_ open documents using office online.
     *
     * @generated from enum value: WOPI_CONSENT_DECLINED = 2;
     */
    WopiConsent[WopiConsent["DECLINED"] = 2] = "DECLINED";
    /**
     * Customer has not made a choice yet. It would be appropriate to ask for consent.
     *
     * @generated from enum value: WOPI_CONSENT_NOT_ANSWERED = 3;
     */
    WopiConsent[WopiConsent["NOT_ANSWERED"] = 3] = "NOT_ANSWERED";
})(WopiConsent || (WopiConsent = {}));
// Retrieve enum metadata with: proto3.getEnumType(WopiConsent)
proto3.util.setEnumType(WopiConsent, "no.jotta.openapi.WopiConsent", [
    { no: 0, name: "WOPI_CONSENT_UNKNOWN" },
    { no: 1, name: "WOPI_CONSENT_ACCEPTED" },
    { no: 2, name: "WOPI_CONSENT_DECLINED" },
    { no: 3, name: "WOPI_CONSENT_NOT_ANSWERED" },
]);
/**
 * @generated from message no.jotta.openapi.UpdateWopiConsentRequest
 */
export class UpdateWopiConsentRequest extends Message {
    /**
     * @generated from field: no.jotta.openapi.WopiConsent consent = 1;
     */
    consent = WopiConsent.UNKNOWN;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.UpdateWopiConsentRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "consent", kind: "enum", T: proto3.getEnumType(WopiConsent) },
    ]);
    static fromBinary(bytes, options) {
        return new UpdateWopiConsentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWopiConsentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWopiConsentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWopiConsentRequest, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.UpdateWopiConsentResponse
 */
export class UpdateWopiConsentResponse extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.UpdateWopiConsentResponse";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new UpdateWopiConsentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UpdateWopiConsentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UpdateWopiConsentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UpdateWopiConsentResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.GetLinksRequest
 */
export class GetLinksRequest extends Message {
    /**
     * Path must be a path to a _file_ of supported type, such as .xlsx or .docx
     *
     * @generated from field: string path = 1;
     */
    path = "";
    /**
     * @generated from field: no.jotta.openapi.WopiActionType action_type = 2;
     */
    actionType = WopiActionType.UNKNOWN_ACTION_TYPE;
    /**
     * Language is optional. Defaults to customer's language.
     *
     * @generated from field: string language = 3;
     */
    language = "";
    /**
     * As session_context you can typically put the link you want the user to end up on after closing the Office Online window.
     * string session_context = 4;
     *
     * @generated from field: string view_link = 5;
     */
    viewLink = "";
    /**
     * @generated from field: string edit_link = 6;
     */
    editLink = "";
    /**
     * @generated from field: string folder_link = 7;
     */
    folderLink = "";
    /**
     * @generated from field: string download_link = 8;
     */
    downloadLink = "";
    /**
     * @generated from field: string close_link = 9;
     */
    closeLink = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.GetLinksRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "action_type", kind: "enum", T: proto3.getEnumType(WopiActionType) },
        { no: 3, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "view_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 6, name: "edit_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "folder_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 8, name: "download_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 9, name: "close_link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetLinksRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLinksRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLinksRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLinksRequest, a, b);
    }
}
/**
 * GetLinksResponse can be used on a hostpage to open a frame to Office Online.
 * See: https://wopi.readthedocs.io/en/latest/hostpage.html#host-page
 *
 * @generated from message no.jotta.openapi.GetLinksResponse
 */
export class GetLinksResponse extends Message {
    /**
     * @generated from oneof no.jotta.openapi.GetLinksResponse.result
     */
    result = { case: undefined };
    /**
     * deprecated fields
     * NB: obos will client probably keep using these for a long time
     *
     * @generated from field: string action_url_deprecated = 1;
     */
    actionUrlDeprecated = "";
    /**
     * @generated from field: string access_token_deprecated = 2;
     */
    accessTokenDeprecated = "";
    /**
     * @generated from field: int64 access_token_ttl_deprecated = 3;
     */
    accessTokenTtlDeprecated = protoInt64.zero;
    /**
     * @generated from field: string app_name_deprecated = 4;
     */
    appNameDeprecated = "";
    /**
     * @generated from field: no.jotta.openapi.WopiActionType action_type_deprecated = 5;
     */
    actionTypeDeprecated = WopiActionType.UNKNOWN_ACTION_TYPE;
    /**
     * @generated from field: string resource_deprecated = 6;
     */
    resourceDeprecated = "";
    /**
     * @generated from field: string fav_icon_url_deprecated = 7;
     */
    favIconUrlDeprecated = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.GetLinksResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 100, name: "links", kind: "message", T: GetLinksResponse_Links, oneof: "result" },
        { no: 101, name: "disabled_by_owner", kind: "message", T: GetLinksResponse_DisabledByOwner, oneof: "result" },
        { no: 1, name: "action_url_deprecated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "access_token_deprecated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "access_token_ttl_deprecated", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 4, name: "app_name_deprecated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "action_type_deprecated", kind: "enum", T: proto3.getEnumType(WopiActionType) },
        { no: 6, name: "resource_deprecated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "fav_icon_url_deprecated", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetLinksResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLinksResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLinksResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLinksResponse, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.GetLinksResponse.Links
 */
export class GetLinksResponse_Links extends Message {
    /**
     * actionurl is the url used to open the Office Online frame
     *
     * @generated from field: string action_url = 1;
     */
    actionUrl = "";
    /**
     * @generated from field: string access_token = 2;
     */
    accessToken = "";
    /**
     * @generated from field: int64 access_token_ttl = 3;
     */
    accessTokenTtl = protoInt64.zero;
    /**
     * appName like EXCEL, ONENOTE or WORD
     *
     * @generated from field: string app_name = 4;
     */
    appName = "";
    /**
     * @generated from field: no.jotta.openapi.WopiActionType action_type = 5;
     */
    actionType = WopiActionType.UNKNOWN_ACTION_TYPE;
    /**
     * @generated from field: string resource = 6;
     */
    resource = "";
    /**
     * WOPI specification says you should change the favicon while viewing a document
     *
     * @generated from field: string fav_icon_url = 7;
     */
    favIconUrl = "";
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.GetLinksResponse.Links";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "action_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 2, name: "access_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 3, name: "access_token_ttl", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
        { no: 4, name: "app_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 5, name: "action_type", kind: "enum", T: proto3.getEnumType(WopiActionType) },
        { no: 6, name: "resource", kind: "scalar", T: 9 /* ScalarType.STRING */ },
        { no: 7, name: "fav_icon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);
    static fromBinary(bytes, options) {
        return new GetLinksResponse_Links().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLinksResponse_Links().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLinksResponse_Links().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLinksResponse_Links, a, b);
    }
}
/**
 * @generated from message no.jotta.openapi.GetLinksResponse.DisabledByOwner
 */
export class GetLinksResponse_DisabledByOwner extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "no.jotta.openapi.GetLinksResponse.DisabledByOwner";
    static fields = proto3.util.newFieldList(() => []);
    static fromBinary(bytes, options) {
        return new GetLinksResponse_DisabledByOwner().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLinksResponse_DisabledByOwner().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLinksResponse_DisabledByOwner().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLinksResponse_DisabledByOwner, a, b);
    }
}
